import {
  MutationCache,
  QueryCache,
  QueryClient,
  VueQueryPlugin,
} from '@tanstack/vue-query';

import useCookie from '@/composables/useCookie';
import { API_CODE, COOKIE_KEY } from '@/constant';
import { defineAppPlugin } from '@/main';

export default defineAppPlugin(context => {
  const token = useCookie<string | null>(COOKIE_KEY.TOKEN);
  const accessToken = useCookie<string | null>(COOKIE_KEY.ACCESS_TOKEN);
  const refreshToken = useCookie<string | null>(COOKIE_KEY.REFRESH_TOKEN);
  const refreshExpired = useCookie<Date | null>(COOKIE_KEY.REFRESH_EXPIRED);

  /**
   * 是否正在換頁，用於判斷已經處發登出流程
   */
  let isRedirecting = false;

  const errorHandle = (error: any) => {
    switch (error.status?.code) {
      case API_CODE.SSO_TOKEN_TEMP_EXIST_ERROR_CODE:
      case API_CODE.SSO_TOKEN_TEMP_NOT_EXIST_ERROR_CODE:
      case API_CODE.SPECIFIC_RECRUITMENT_PERSON_CANNOT_LOGIN_FRONTEND:
      case API_CODE.USER_ROLE_JOB_TYPE_OFFICE_NOT_EXIST_ERROR_CODE: {
        if (isRedirecting) return;

        token.value = null;
        accessToken.value = null;
        refreshToken.value = null;
        refreshExpired.value = null;
        isRedirecting = true;

        context.$message({
          type: 'error',
          message: error.status.message,
        });

        context.$router.push({
          name: 'auth',
        });
        break;
      }

      default: {
        context.$message({
          type: 'error',
          message: error.status?.message || error?.message || '未捕獲的錯誤',
        });
      }
    }
  };

  const queryCache = new QueryCache({
    onError: errorHandle,
  });

  const mutationCache = new MutationCache({
    onError: errorHandle,
  });

  const queryClient = new QueryClient({
    queryCache,
    mutationCache,
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,

        // 預設 30 秒過期
        // @see https://twitter.com/TkDodo/status/1687454784209448962
        staleTime: 30000,

        // 基本 retry 3 次
        // 如果是登入問題則直接退回登入頁面
        retry(failureCount, error: any) {
          if (
            error?.status?.message ||
            failureCount >= 2 ||
            [
              API_CODE.SSO_TOKEN_TEMP_EXIST_ERROR_CODE,
              API_CODE.SSO_TOKEN_TEMP_NOT_EXIST_ERROR_CODE,
              API_CODE.USER_ROLE_JOB_TYPE_OFFICE_NOT_EXIST_ERROR_CODE,
            ].includes((error as any)?.status?.code)
          ) {
            return false;
          }

          return true;
        },
      },
    },
  });

  context.app.use(VueQueryPlugin, {
    queryClient,
  });
});
